import { styled } from '@mui/material/styles';

import getSharedInputStyles from './shared-input-styles';

const StyledInput = styled('input')(({ theme }) => ({
  ...getSharedInputStyles(theme),
}));

export default StyledInput;
